module.exports = __webpack_public_path__ + "static/img/earth.2f8a6ada.png";